import { Skeleton, Stack, Typography } from "@mui/material";

import { FilterTable } from "../../../../../Components/FilterTable/FilterTable";
import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../../../Components/FilterTable/filterTableUtils";
import { type DashboardWorkload } from "../../../types";
import { useClusterDetailDashboardContext } from "../context";
import WorkloadsTableRow from "./WorkloadsTableRow";

const WorkloadsTable = ({ clusterId, timeRange }) => {
  const { dashboardWorkloads, loading: workloadsLoading } = useClusterDetailDashboardContext();
  const showCostColumn = !["1h", "4h", "12h"].includes(timeRange ?? "");
  const costColumn: FilterTableItemDescriptor<DashboardWorkload>[] = showCostColumn
    ? [
        {
          headerText: "Total cost",
          value: "totalCost",
          filterType: "number",
          headerStyle: { align: "right" as const },
        },
      ]
    : [];

  const itemDescriptions: FilterTableItemDescriptor<DashboardWorkload>[] = [
    {
      headerText: "",
      value: "@",
      disableSorting: true,
    },
    {
      headerText: "Name",
      value: "name",
      filterType: "string",
    },
    {
      headerText: "Type",
      value: "type",
      filterType: "string",
    },
    {
      headerText: "Namespace",
      value: "namespace",
      filterType: "string",
    },
    ...costColumn,
    {
      headerText: "Container",
      value: "@",
      disableSorting: true,
    },
    {
      headerText: "CPU request",
      value: "@",
      disableSorting: true,
      headerStyle: {
        align: "right",
      },
    },
    {
      headerText: "CPU limit",
      value: "@",
      disableSorting: true,
      headerStyle: {
        align: "right",
      },
    },
    {
      headerText: "Memory request",
      value: "@",
      disableSorting: true,
      headerStyle: {
        align: "right",
      },
    },
    {
      headerText: "Memory limit",
      value: "@",
      disableSorting: true,
      headerStyle: {
        align: "right",
      },
    },
  ];

  const { headerColumns, filters } = generateHeadersAndFilters(itemDescriptions);

  return (
    <Stack>
      <Typography variant="h4" sx={{ mb: workloadsLoading ? 0 : -2 }}>
        Workloads {workloadsLoading ? null : `(${dashboardWorkloads?.length ?? 0})`}
      </Typography>
      {workloadsLoading ? (
        <Skeleton variant="rectangular" width="100%" height={300} animation="wave" />
      ) : (
        <FilterTable<DashboardWorkload>
          rowComponent={(props) => <WorkloadsTableRow {...props} clusterId={clusterId} timeRange={timeRange} />}
          persistenceKey="k8s-workloads-table"
          tableItems={dashboardWorkloads ?? []}
          headerColumns={headerColumns}
          filterColumns={filters}
          defaultSortDirection="desc"
          defaultSortingColumnValue="totalCost"
          wrapRowComponent={false}
          tableProps={{
            size: "small",
          }}
          filterAreaSXProp={{
            marginBottom: 1,
          }}
        />
      )}
    </Stack>
  );
};

export default WorkloadsTable;
